import { css, keyframes } from '@emotion/core'
import { Theme } from '@themes/theme'
import { PCMaxWidth, mq, mqMin } from '@styles/base.style'
import { topNoticeH } from '@views/Notice/index.style'
import { PopularSearchTermH } from '@components/PopularSearchTerm/index.style'

const menuBgAni = keyframes`
  0% {
    background-position: 0 50%;
  }
  100% {
    background-position: 100% 50%;
  }
`
// pc
export const PCLayout = (theme: Theme) => css`
  width: ${PCMaxWidth};
  margin: 0 auto;
  display: flex;
  flex-wrap: nowrap;
  ${mq[7]} {
    margin: 0;
  }
  &.event-page-layout {
    width: 1280px;
  }
  /* 점검 페이지 wrap */
  .server-check-wrap {
    position: absolute;
    top: calc(50% + 30px);
    left: 50%;
    padding: 0 25vw 0;
    transform: translate(-50%, -50%);
    width: 100%;
    min-width: 962px;
    /* 점검 페이지 - 상단 */
    .notice-wrap {
      width: 100%;
      padding: 5vh 7vw 28px;
      background: #212732;
      border-radius: 50px; // 배너가 없을 시 배경 곡선 처리
      transition: all .3s;
      .notice-img {
        max-height: 162px;
      }
      .notice-txt {
        font-size: 1.6rem;
        line-height: 2.4rem;
        margin: 14px auto 22px;
      }
      .notice-btn {
        font-size: 1.4rem;
        max-width: 270px;
        display: block;
        margin: 0 auto 16px;
        :not(&.naver-cafe) {
          margin: 0 auto;
        }
        .naver-cafe-img, svg {
          width: 26px;
          left: 12px;
        }
        svg {
          height: 16px;
        }
      }
    }
    /* 점검 페이지 - 배너 존재 시 상단콘텐츠 스타일 */
    &.is-banner {
      .notice-wrap {
        border-radius: 50px 50px 0 0;
      }
    }
    /* 점검 페이지 - 배너 */
    .notice-banner-wrap {
      padding: 28px 7vw 60px;
      display: flex;
      justify-content: center;
      flex-wrap: nowrap;
      background: #212732;
      border-radius: 0 0 50px 50px;
      position: relative;
      :before {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 59%;
        background: #1C202B;
        box-shadow: 0 1px 0 #2A323E;
      }
      > button {
        width: 59%;
        margin-right: 1.7%;
        > img {
          border-radius: 10px;
          box-shadow: 0 2px 6px #00000033;
        }
      }
      .champ-down-btn-wrap {
        width: 22%;
        flex-wrap: wrap;
        flex-flow: column;
        justify-content: center;
        margin: 0;
        align-content: flex-end;
        .champ-down-btn {
          width: 100%;
          margin: 2% 0;
          > img {
            aspect-ratio: 145/41;
          }
        }
      }
    }
  }
  .adv-pc {
    display: block;
  }
  .pc-bg {
    z-index: -1;
    position: absolute;
    bottom: 0;
    width: 100vw;
    min-width: ${PCMaxWidth};
    height: auto;
    min-height: 1026px;
    opacity: .1;
    ${mqMin[8]} {
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
  .pc-menu {
    z-index: 0;
    position: relative;
    top: 60px;
    width: auto;
    &--list {
      &--item {
        width: 255px;
        .menu {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 19px 27px;
          width: 100%;
          height: 60px;
          background: ${theme.color.mainBg};;
          border: none;
          //border: 1px solid rgba(110,119,127,.3);
          backdrop-filter: blur(5px);
          &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: inherit;
            background: linear-gradient(130deg, rgba(80, 96, 112, .2), rgba(80, 96, 112, .1));
            border: 1px solid rgba(110, 119, 127, .3);
            transition: all .15s;
          }
          svg {
            width: 22px;
            margin-right: 20px;
            path:not(.none) {
              fill: ${theme.color.modalSubBg};
            }
          }
          &--txt {
            flex: 1;
            text-align: left;
            color: ${theme.color.modalSubBg};
            font-size: ${theme.font.large};
            font-weight: ${theme.fontW.medium};
            transform: translateY(1px);
          }
          &--arrow {
            position: relative;
            transform: rotate(45deg);
            &::before, &::after {
              content: '';
              display: block;
              position: absolute;
              top: 0;
              right: 0;
              width: 1px;
              height: 8px;
              background: #39414B;
              border-radius: 10px;
            }
            &::after {
              width: 8px;
              height: 1px;
            }
          }
          &:focus:not(.link), &:hover, &:active {
            &::before {
              border: 1px solid rgba(211, 211, 211, .7);
              background: linear-gradient(130deg, rgba(238, 238, 238, .25) 20%, rgba(110, 119, 127, .25), rgba(172, 177, 181, .18), rgba(238, 238, 238, .25) 83%);
              background-size: 800% 800%;
              animation: ${menuBgAni} 4s cubic-bezier(.35, .14, .85, .6) infinite;
            }
            .menu--txt {
              color: ${theme.color.themeTxt};
            }
            .menu--arrow {
              &::before, &::after {
                background: ${theme.color.themeTxt};
              }
            }
            svg path:not(.none) {
              fill: ${theme.color.themeTxt};
            }
          }
        }
      }

      // &--item {
      //   position: relative;
      //   height: 76px;
      //   margin: 14px 0;
      //   text-align: center;
      //   svg {
      //     display: block;
      //     margin: 0 auto 6px;
      //     width: 28px;
      //     height: 28px;
      //   }
      //   button.menu {
      //     background: transparent;
      //     border: none;
      //   }
      //   .menu {
      //     display: block;
      //     width: 100%;
      //     height: 100%;
      //     padding: 15px 0;
      //     transition: none;
      //     cursor: pointer;
      //     &.club-portal {
      //       svg path {
        //         fill: ${theme.color.yellow};
      //       }
      //     }
      //     &.link {
      //       svg path {
        //         fill: ${theme.color.themeTxt};
      //       }
      //     }
      //     &:focus:not(.link),&:hover,&:active {
        //       color: ${theme.color.blue} !important;
      //       svg path {
        //         fill: ${theme.color.blue} !important;
      //       }
      //     }
      //     .fill {
        //       fill: ${theme.color.themeTxt};
      //     }
      //   }
      // }
    }
  }
  .pc-layout {
    position: relative;
    display: flex;
    max-width: 1100px;
    height: calc(100vh - 61px);
    top: 61px !important;
    flex-direction: row !important;
    min-height: 858px; // pc-menu 컨텐츠 높이
    .main-page > main, .sub-page {
      padding: 0 15px;
    }
    .main-page, .sub-page {
      flex: 1;
      position: relative;
      max-width: 50%;
      height: calc(100% - 20px);
      //padding: 0 15px;
      overflow: hidden;
      &:first-of-type {
        border-right: 1px solid #393C46;
      }
      .floating-btn {
        left: 50%;
        transform: translate(-300%, 0);
        ${mq[7]} {
          transform: translate(-280%, 0);
        }
        ${mq[6]} {
          transform: translate(-100%, 0);
        }
        ${mq[5]} {
          transform: translate(100%, 0);
        }
        ${mq[4]} {
          transform: translate(280%, 0);
        }
        transition: all .3s;
      }
      /* 각 페이지 header부분 */
      .club-notice-container, .title-wrap {
        height: 60px;
        line-height: 6rem;
      }
      /* club */
      .club-notice-container {
        .row .ant-col {
          display: flex;
          align-items: center;
        }
        .club-names {
          font-size: ${theme.font.xlarge};
          margin-right: 6px;
          /* 클럽 엠블렘 */
          svg {
            width: 21px;
            margin-right: 10px;
          }
        }
        .button-wrap button {
          top: 0;
        }
      }
      /* 게스트 모드 */
      .guest {
        height: 27px;
      }
      /* page header */
      .title-wrap {
        justify-content: center;
        .title {
          font-size: ${theme.font.title};
        }
        &.sticky {
          top: 0;
        }
      }
      /* 종목 탭 / 상세 경기 탭 */
      .detail-tab, .filter-tab {
        .am-tabs-default-bar-top .am-tabs-default-bar-content,
        .am-tabs-default-bar-bottom .am-tabs-default-bar-content {
          transform: none !important; /* 탭을 눌렀을때 왼쪽으로 이동되는 현상 해결 */
        }
        /* scroll bar가 보일수 있도록 수정 */
        .am-tabs-default-bar {
          overflow-x: auto !important;
        }
        .am-tabs-default-bar-content {
          overflow: hidden;
          overflow-x: auto !important;
          height: auto;
        }
      }
      // PC
      .match-list {
        margin-bottom: 0;
        .am-list {
          margin-bottom: 10px;
          .am-list-view-scrollview-content {
            max-width: 100%;
          }
        }
        /* 스포츠, 라이브 리스트 */
        &.cross, &.live {
          height: calc(100% - 200px);
          &.visible-popular-search-term {
            height: calc(100% - 200px - ${PopularSearchTermH});
          }
          &.visible-top-notice {
            height: calc(100% - (200px + ${topNoticeH}));
            &.visible-popular-search-term {
              height: calc(100% - (200px + ${topNoticeH}) - ${PopularSearchTermH});
            }
          }
        }
        &.matchupFilter, &.matchupResultFilter {
          height: calc(100% - 106px);
          &.visible-popular-search-term {
            height: calc(100% - 106px - ${PopularSearchTermH});
          }
        }
        /* 스페셜 리스트 */
        &.special {
          height: calc(100% - 106px);
          &.visible-popular-search-term {
            height: calc(100% - 106px - ${PopularSearchTermH});
          }
        }
        /* 경기 결과 리스트 */
        &.matchupResult {
          height: calc(100% - 189px - 55px);
          &.visible-popular-search-term {
            height: calc(100% - 189px - ${PopularSearchTermH});
          }
        }
        // 게스트 모드 - 스포츠/라이브
        &.guest-list {
          height: calc(100% - 196px);
          &.visible-popular-search-term {
            height: calc(100% - 196px - ${PopularSearchTermH});
          }
        }
      }
      .team-name {
        /* 상세 경기 마켓명 */
        &.detail {
          &.special {
            width: auto; /* 불필요하게 2줄로 나오는 현상 해결 */
          }
        }
      }
      /* loading 자리(loading이 안떠서 0값 줌) */
      .am-list-footer {
        /* margin-top: 0; */
      }
      .bet-history-wrap {
        .bottom-wrap::before {
          max-width: 414px;
        }
      }

      /* 가이드 */
      .guide-nav-wrap {
        top: 0;
      }
      .guide-section {
        &--target {
          top: 10px;
        }
      }
      .count-ani-wrap {
        position: -webkit-sticky;
        position: sticky;
        bottom: 8px;
      }
      /* 점검 페이지 */
      .notice-wrap {
        width: 50%;
        min-width: 600px;
        margin: 10% auto;
      }
      // 클럽 이벤트 리스트 팝업
      .event-menu {
        .club-event-button-tit {
          top: 76px;
        }
        .menu-open:checked ~ .arrow-button {
          left: 50%;
          top: 88px;
          transform: translate3d(450%, 0, 0) scale(1, 1);
        }
        .club-event {
          max-width: 350px;
        }
      }
    }
    /* 종목 탭 (ChildTabWrap) */
    .match-child-tab {
      top: 0;
      .am-tabs-default-bar-tab {
        min-width: 70px;
        padding: 2px 10px;
      }
    }
    .match {
      //top: 30px;
      height: auto;
      min-height: 51px;
      &::after {
        height: 44px;
      }
      .am-tabs-tab-bar-wrap {
        //height: inherit;
      }
      &::before {
        max-width: 541px;
        height: inherit;
      }
      .match-info {
        line-height: 5.2rem;
      }
      .match-num {
        top: 7px;
      }
      .tab-sub-wrap {
        &.today-league {
          height: inherit;
          margin: 0;
          border-radius: 0;
          &::before {
            border-radius: 0;
          }
        }
        &.sports-major-league {
          .major-league-tag {
            width: 54px;
            height: 24px;
            margin-right: 12px;
            padding: 0 8px;
            .sports-major-league-img {
              width: 12px;
            }
          }
        }
      }
      .am-tabs-default-bar-tab {
        min-width: 0 !important;
        max-width: none;
        height: 51px;
      }
    }
    .tournament-info {
      .match-block-header {
        padding: 0 12px 0 12px;
      }
    }
    /* *** empty *** */
    .adv-empty-match-live {
      max-height: 650px;
    }
    .empty-wrap, .empty-wrap.adv-empty-match-detail, .empty-wrap.adv-empty-match {
      width: 100%;
      left: 0;
      transform: translate(0, -50%) !important;

    }
    /* empty - 상세 경기 */
    .adv-empty-match-detail {
      height: 100vh !important;
      max-height: 790px;
      &.contents-tab {
        max-height: 660px;
      }
    }
  }

  .pc-betslip {
    position: relative;
    top: 60px;
    width: 290px;
    height: auto;
    .betslip-bottom {
      position: relative;
      width: 100%;
      .wrapping {
        position: relative;
        .toggle-betslip-btn {
          display: none;
        }
        .bet-list {
          min-height: 344px;
          max-height: 344px;
        }
        .bet-detail-info {
          justify-content: space-between;
          & > li {
            &:first-of-type {
              width: 120px;
            }
            &:nth-of-type(2) {
              width: 134px;
              padding: 0;
            }
            &:nth-of-type(3), &:nth-of-type(4) {
              width: 100%;
              padding: 0 4px;
            }
            .detail-num.max-value {
              padding-right: 0;
            }
          }
        }
        .bet-input {
          width: 100%;
        }
        .bet-btn {
          width: calc((100% - 8px) / 3);
          margin-top: 4px;
          &.bet-coupon {
            padding: 0 14px;
          }
          &:not(.other, .bet-coupon) {
            justify-content: flex-end;
            padding: 0 6px;
          }
        }
        .bet-complete-alert {
          .bubble-contents {
            left: 14px;
          }
        }
      }
    }
    .pc-betslip-sider {
      display: none;
    }
  }
  /* 라이브 베팅 후 카운트 영역 */
  .live-count-wrap {
    max-width: ${PCMaxWidth};
  }
  .sub-page, .pc-betslip {
    .live-count-wrap {
      display: none; /* main page에 있는 것과 동일한 것이므로 생략 */
    }
  }
  .gift-box-alert-bubble {
    position: absolute;
    top: 12px;
    left: 84px;
    width: 94px;
    height: auto;
  }
`
export const PCScrollStyle = () => css`
  overflow-y: auto;
  height: 100vh;
  overflow-x: hidden;
  min-width: ${PCMaxWidth};
`
